/*  
    用于照片视频全屏预览
    依赖： jky-modalstatic.css
    使用： 
        Modla结构： modal-id允许多组预览
            <jky-modalstatic modal-id="highlight">
                <div class="highlight_modal modalstatic"></div>
                <div class="highlight_modal_mask"></div>
            </jky-modalstatic>

        选择器结构： modal-id允许多组预览 modal-id 匹配容器id     template结构中为视频或img需要全屏展示的内容
            <div class="highlight-item-xxx modalstatic-btn" modal-id="highlight">
                <img class=" lazyloaded" data-src="//shop.sit-eu.jackery.com/cdn/shop/files/330X330-2.jpg?v=1703747803" alt="" loading="lazy" src="//shop.sit-eu.jackery.com/cdn/shop/files/330X330-2.jpg?v=1703747803">
                
                <template>
                    <img class="lazyload" data-src="//shop.sit-eu.jackery.com/cdn/shop/files/330X330-2.jpg?v=1703747803" alt="" loading="lazy">  
                </template>
            </div>

            <div class="highlight-item modalstatic-btn" modal-id="highlight" style=" grid-column: span 2/span 2;">
              <img class=" lazyloaded" data-src="//shop.sit-eu.jackery.com/cdn/shop/files/b7b91583f9d3bfdb35c624ccc9f9e5f1.jpg?v=1704268397" alt="" loading="lazy" src="//shop.sit-eu.jackery.com/cdn/shop/files/b7b91583f9d3bfdb35c624ccc9f9e5f1.jpg?v=1704268397">
                <span class="absolute iconfont jackery-icon-playCircle"></span>
            <template>
                <video name="media" muted="" preload="none" data-autoplay="" controls="" class="lazyload" data-poster="//shop.sit-eu.jackery.com/cdn/shop/files/b7b91583f9d3bfdb35c624ccc9f9e5f1.jpg?v=1704268397&amp;width=480" data-src="https://terra-1-g.djicdn.com/851d20f7b9f64838a34cd02351370894/%E5%A4%A9%E7%A9%BA%E4%B9%8B%E5%9F%8E%209%20%E5%91%A8%E5%B9%B4%E5%BD%B1%E5%83%8F%E5%A4%A7%E8%B5%9B/1124.mp4">
                    <source src="https://terra-1-g.djicdn.com/851d20f7b9f64838a34cd02351370894/%E5%A4%A9%E7%A9%BA%E4%B9%8B%E5%9F%8E%209%20%E5%91%A8%E5%B9%B4%E5%BD%B1%E5%83%8F%E5%A4%A7%E8%B5%9B/1124.mp4" type="video/mp4">
                </video>
            </template>
          </div>
*/

import {isMobile, setContentWidth, resetContentWidth, } from "@utils/index.js";

export default function() {
    if (!customElements.get('jky-modalstatic')) {
        customElements.define(
            'jky-modalstatic',
            class JkyModalStatic extends HTMLElement {
                constructor() {
                    super();
                    this.mobile = isMobile() || false
                    this.modalID = this.getAttribute("modal-id")
                    this.modal = this.querySelector(".modalstatic"); // modal 容器
                    this.mask = this.querySelector(".highlight_modal_mask"); // mask遮罩
                    this.scale = 1;
                    this.scale_min = 0.2;
                    this.scale_max = 4;
                    this.scale_step = 0.2;
                    this.store = {
                      scale: this.scale || 1
                    };
                    this.list = document.querySelectorAll(`.modalstatic-btn[modal-id=${this.modalID}]`);
                    this.btns = $(`.modalstatic-btn[modal-id=${this.modalID}]`); // modal开启按钮
    
                    this.init();
                }
    
                init() {
                  const this_ = this
                  this.btns.click(function(e) {
                    this_.current = $(this).index() + 1;
                    this_.open($(this)[0]);
                  })
    
                  this.mask.addEventListener("click", () => {
                    this.close();
                  })
    
                  this.modal.addEventListener("click", (e) => {
                    const excludedElement = this.modal.querySelector(".modal_custom_div")
                    if (excludedElement && (e.target === excludedElement || excludedElement.contains(e.target))) {
                      return;
                    }
    
                    this.close();
                  })
                }
    
                open(dom) {
                  this.loadContent(dom);
                  const {x, y} = this.getDomPosCenter(dom);
                  this.modal.style.transformOrigin = [ x, 'px', ' ', y, 'px' ].join('');
    
                  this.modal.classList.add('visible');
                  this.classList.add('open');
    
                  !this.rendered && this.render();
    
                  this.updateAnctionStatus();
                  this.moveContent();
                  // 设置 内容区域 宽度，防止 页面闪烁
                  setContentWidth()
    
                  if(this.modal.querySelector(".modal_custom_div video")) {
                    setTimeout(() => {
                      console.log("vivvvvvdeo")
                      console.log(this.modal.querySelector(".modal_custom_div video"))
                      this.modal.querySelector(".modal_custom_div video").addEventListener("canplay", () => {
                        this.modal.querySelector(".modal_custom_div video").play()
                      })
                    }, 100);
                  }
                }
    
                // 获取动画center 坐标
                getDomPosCenter(dom) {
                  var rect = dom.getBoundingClientRect();
                  var _x = rect.left + rect.width / 2,
                      _y = rect.top + rect.height / 2;
    
                  var _wid = window.innerWidth,
                      _hei = window.innerHeight,
                      _mWid = this.modal.offsetWidth,
                      _mHei = this.modal.offsetHeight,
                      x,
                      y;
                  
                  x = (_x - (_wid / 2)) + _mWid / 2;
                  y = (_y - (_hei / 2)) + _mHei / 2;
                  this.pos_x = x
                  this.pos_y = y
                  return {x, y}
                }
    
                close() {
                  if(this.modal.querySelector(".modal_custom_div video")) {
                    setTimeout(() => {
                      this.modal.querySelector(".modal_custom_div video").pause();
                    }, 100)
                  }
    
                  this.modal.classList.remove('visible');
                  this.classList.remove('open');
                  // 恢复 内容区域 宽度
                  resetContentWidth()
                }
    
                // 更新操作按钮状态
                updateAnctionStatus() {
                  const next = this.querySelector(".jky-image-preview-switch-right");
                  const prev = this.querySelector(".jky-image-preview-switch-left");
                  const progress = this.querySelector(".jky-image-preview-progress");
                  if(next) {
                    if(this.current === this.list.length) {
                      next.classList.add("disabled");
                    } else {
                      next.classList.remove("disabled");
                    }
                  }
    
                  if(prev) {
                    if(this.current === 1) {
                      prev.classList.add("disabled");
                    } else {
                      prev.classList.remove("disabled");
                    }
                  }
    
                  progress.innerText = `${this.current} / ${this.list.length}`
                }
    
                // 绑定操作按钮事件
                initRenderEvent() {
                  const close = this.querySelector(".jky-image-preview-close");
                  const next = this.querySelector(".jky-image-preview-switch-right");
                  const prev = this.querySelector(".jky-image-preview-switch-left");
                  const flipY = this.querySelector(".jky-image-preview-operations-operation.jky-image-preview-operations-operation-flipY");
                  const flipX = this.querySelector(".jky-image-preview-operations-operation.jky-image-preview-operations-operation-flipX");
                  const zoomout = this.querySelector(".jky-image-preview-operations-operation.jky-image-preview-operations-operation-zoomOut");
                  const zoomin = this.querySelector(".jky-image-preview-operations-operation.jky-image-preview-operations-operation-zoomIn");
    
                  console.log("length", this.list.length)
                  console.log("current", this.current)
    
    
                  close && close.addEventListener("click", () => {
                    this.close();
                  })
    
                  next && next.addEventListener("click", () => {
                    this.nextView();
                  })
    
                  prev && prev.addEventListener("click", () => {
                    this.prevView();
                  })
    
                  flipY && flipY.addEventListener("click", () => {
                    // matrix(1, 0, 0, -1, -203.5, -325.5);
                    const img = this.modal.querySelector("img");
                    const pimg = this.modal.querySelector(".modal_custom_div");
                    if(img && pimg) {
                      let computedStyle = getComputedStyle(pimg);
                      let customVariableY = Number(computedStyle.getPropertyValue('--scaleY')) || 1;
                      customVariableY = -customVariableY;
                      pimg.style.setProperty('--scaleY', `${customVariableY}`);
                    }
                  })
    
                  flipX && flipX.addEventListener("click", () => {
                    const img = this.modal.querySelector("img");
                    const pimg = this.modal.querySelector(".modal_custom_div");
                    if(img && pimg) {
                      let computedStyle = getComputedStyle(pimg);
                      let customVariable = Number(computedStyle.getPropertyValue('--scale')) || 1;
                      customVariable = -customVariable
                      pimg.style.setProperty('--scale', `${customVariable}`);
                    }
                  })
    
                  zoomout && zoomout.addEventListener("click", () => {
                    this.scale -= this.scale_step;
                    zoomin.classList.remove("disabled");
                    if(this.scale <= this.scale_min) {
                      this.scale = this.scale_min;
                      zoomout.classList.add("disabled");
                      return;
                    }
    
                    const pimg = this.modal.querySelector(".modal_custom_div");
    
                    let computedStyle = getComputedStyle(pimg);
                    let customVariableY = Number(computedStyle.getPropertyValue('--scaleY')) || 1;
                    let customVariable = Number(computedStyle.getPropertyValue('--scale')) || 1;
                    customVariableY = customVariableY > 0 ? this.scale : -this.scale;
                    customVariable = customVariable > 0 ? this.scale : -this.scale;
    
                    pimg.style.setProperty('--scaleY', `${customVariableY}`);
                    pimg.style.setProperty('--scale', `${customVariable}`);
                  })
    
                  zoomin && zoomin.addEventListener("click", () => {
                    this.scale += this.scale_step;
                    zoomout.classList.remove("disabled");
                    if(this.scale >= this.scale_max) {
                      this.scale = this.scale_max;
                      zoomin.classList.add("disabled");
                      return;
                    }
    
                    const pimg = this.modal.querySelector(".modal_custom_div");
    
                    let computedStyle = getComputedStyle(pimg);
                    let customVariableY = Number(computedStyle.getPropertyValue('--scaleY')) || 1;
                    let customVariable = Number(computedStyle.getPropertyValue('--scale')) || 1;
                    customVariableY = customVariableY > 0 ? this.scale : -this.scale;
                    customVariable = customVariable > 0 ? this.scale : -this.scale;
    
                    pimg.style.setProperty('--scaleY', `${customVariableY}`);
                    pimg.style.setProperty('--scale', `${customVariable}`);
                  })
                }
    
                nextView() {
                  if(this.current === this.list.length) return;
                  this.current = this.current + 1;
                  this.updateAnctionStatus();
                  const next_img = this.list[this.current - 1];
                  this.open(next_img);
                }
    
                prevView() {
                  if(this.current === 1) return;
                  this.current = this.current - 1;
                  this.updateAnctionStatus();
                  const prev_img = this.list[this.current - 1];
                  this.open(prev_img);
                }
    
                setStyle(imgElement, styleObj) {
                  for (const key in styleObj) {
                    imgElement.style[key] = styleObj[key]
                  }
                }
    
                // 鼠标拖动图片位置变化
                moveContent() {
                    const this_ = this;
                    const excludedElement = this.modal.querySelector(".modal_custom_div");
                    var isDragging = false;
                    var initialTransform = getComputedStyle(excludedElement).transform;
                    excludedElement && excludedElement.addEventListener('mousedown', (e) => {
                      if (e.target.localName !== 'img') return;
                      isDragging = true;
                      let diffX = e.clientX - e.target.offsetLeft;
                      let diffY = e.clientY - e.target.offsetTop;
                      e.preventDefault();
                      excludedElement.classList.add('moving');
                      excludedElement['onmousemove'] = function (e) {
                        if(isDragging) {
                          let moveX = e.clientX - diffX
                                  let moveY = e.clientY - diffY
                          this_.setStyle(e.target, {
                            top: `${moveY}px`,
                            left: `${moveX}px`
                          })
                        }
    
                      
                      }
                      excludedElement['onmouseup'] = function () {
                        isDragging = false;
                        this.onmousemove = null
                        excludedElement.classList.remove('moving')
                      }
                    })
    
                    if(this.mobile) {
                      this.enableMobileScale(excludedElement);
                    } else {
                      this.enablePCwheel(excludedElement);
                    }
                }
    
                // 移动端双指缩放&单指拖拽 - Mobile touch
                enableMobileScale(wrapper) {
                  const this_ = this;
                  let element = wrapper;
                  let eleImg = wrapper.querySelector("img");
                  if(!eleImg) return
                  let initialX,
                      initialY,
                      isDragging,
                      offsetX = 0,
                      offsetY = 0;
                  eleImg.addEventListener('touchstart', function (event) {
                    let touches = event.touches;
                    let events = touches[0];
                    let events2 = touches[1];
                    if(!events) return;
                    event.preventDefault();
                    // 第一个触摸点的坐标
                    this_.store.pageX = events.pageX;
                    this_.store.pageY = events.pageY;
                    this_.store.moveable = true;
    
                    if (events2) {
                      this_.store.pageX2 = events2.pageX;
                      this_.store.pageY2 = events2.pageY;
                    } else {
                      let touch = event.touches[0];
    
                      initialX = touch.clientX - event.target.offsetLeft;
                      initialY = touch.clientY - event.target.offsetTop;
                      isDragging = true;
                      eleImg.classList.add("dragging");
                    }
    
                    this_.store.originScale = this_.store.scale || 1;
                  });
    
                  eleImg.addEventListener('touchmove', function (event) {
                    var touches = event.touches;
                    var events2 = touches[1];
                    var events = touches[0];
                    if(!events2 && events && isDragging) {
                      let touch = event.touches[0];
                      offsetX = touch.clientX - initialX;
                      offsetY = touch.clientY - initialY;
                      eleImg.style.left = offsetX + 'px';
                      eleImg.style.top = offsetY + 'px';
                    }
                  })
    
                  eleImg.addEventListener('touchend', function(event) {
                    isDragging = false;
                    eleImg.classList.remove("dragging");
                  });
    
                  document.addEventListener('touchmove', function (event) {
                    if (!this_.store.moveable) {
                      return;
                    }
    
                    event.preventDefault();
    
                    var touches = event.touches;
                    var events = touches[0];
                    var events2 = touches[1];
                    if (events2) { // 双指缩放
                      // 第2个指头坐标在touchmove时候获取
                      if (!this_.store.pageX2) {
                        this_.store.pageX2 = events2.pageX;
                      }
                      if (!this_.store.pageY2) {
                        this_.store.pageY2 = events2.pageY;
                      }
    
                      // 获取坐标之间的举例
                      var getDistance = function (start, stop) {
                        return Math.hypot(stop.x - start.x, stop.y - start.y);
                      };
                      // 双指缩放比例计算
                      var zoom = getDistance({
                          x: events.pageX,
                          y: events.pageY
                        }, {
                          x: events2.pageX,
                          y: events2.pageY
                        }) /
                        getDistance({
                          x: this_.store.pageX,
                          y: this_.store.pageY
                        }, {
                          x: this_.store.pageX2,
                          y: this_.store.pageY2
                        });
                      // 应用在元素上的缩放比例
                      var newScale = this_.store.originScale * zoom;
                      // 最大缩放比例限制
                      if (newScale > 3) { newScale = 3; }
                      this_.store.scale = newScale;
    
                      let computedStyle = getComputedStyle(element);
                      let customVariableY = Number(computedStyle.getPropertyValue('--scaleY')) || 1;
                      let customVariable = Number(computedStyle.getPropertyValue('--scale')) || 1;
                      customVariableY = customVariableY > 0 ? newScale : -newScale;
                      customVariable = customVariable > 0 ? newScale : -newScale;
    
                      element.style.setProperty('--scale', `${customVariable}`);
                      element.style.setProperty('--scaleY', `${customVariableY}`);
                    }
                  });
    
                  document.addEventListener('touchend', function () {
                    this_.store.moveable = false;
    
                    delete this_.store.pageX2;
                    delete this_.store.pageY2;
                  });
                  document.addEventListener('touchcancel', function () {
                    this_.store.moveable = false;
    
                    delete this_.store.pageX2;
                    delete this_.store.pageY2;
                  });
                }
    
                // PC端鼠标滚轮事件 - 拖拽
                enablePCwheel(excludedElement) {
                  let this_ = this
                  excludedElement.addEventListener('wheel', (event) => {
                    event.preventDefault(event)
                    if (event.target.localName !== 'img') return
                    // let { min, max, step } = mergeOptions.imageZoom
                    let min = this_.scale_min,
                        max = this_.scale_max,
                        step = this_.scale_step;
                    if (event.wheelDelta > 0) { // zoom
                      const scale = step + this_.scale
                      this_.scale = scale > max ? max : scale
                    } else { // zoom out
                      const scale = this_.scale - step;
                      this_.scale = scale < min ? min : scale;
                    }
    
                    let computedStyle = getComputedStyle(excludedElement);
                    let customVariableY = Number(computedStyle.getPropertyValue('--scaleY')) || 1;
                    let customVariable = Number(computedStyle.getPropertyValue('--scale')) || 1;
                    customVariableY = customVariableY > 0 ? this_.scale : -this_.scale;
                    customVariable = customVariable > 0 ? this_.scale : -this_.scale;
    
                    excludedElement.style.setProperty('--scale', `${customVariable}`);
                    excludedElement.style.setProperty('--scaleY', `${customVariableY}`);
                  })
                }
    
                loadContent(dom) { // 渲染modal内容
                  this.modal.querySelector(".modal_custom_div") && this.modal.querySelector(".modal_custom_div").remove();
                  if(!dom.querySelector('template')) return
                  const content = document.createElement('div');
                  content.classList.add("modal_custom_div")
                  content.appendChild(dom.querySelector('template').content.firstElementChild.cloneNode(true));
                  this.modal.appendChild(content);
                }
    
                render() { // 渲染模态框除modal内容之外的元素 - mask、action等
                  let fragment = document.createDocumentFragment();
                  
                  // 关闭按钮
                  let closeDom = document.createElement('button');
                  closeDom.classList.add("jky-image-preview-close");
                  closeDom.innerHTML = `<span role="img" aria-label="close" class="anticon anticon-close"><svg fill-rule="evenodd" viewBox="64 64 896 896" focusable="false" data-icon="close" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"></path></svg></span>`
    
    
                  // 下一页按钮
                  let next = document.createElement('div');
                  next.classList.add("jky-image-preview-switch-right");
                  next.innerHTML = `<span role="img" aria-label="right" class="anticon anticon-right"><svg viewBox="64 64 896 896" focusable="false" data-icon="right" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"></path></svg></span>`
    
                  // 上一页按钮
                  let prev = document.createElement('div');
                  prev.classList.add("jky-image-preview-switch-left");
                  prev.innerHTML = `<span role="img" aria-label="right" class="anticon anticon-right"><svg viewBox="64 64 896 896" focusable="false" data-icon="right" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"></path></svg></span>`
    
                  // 中间操作action
                  let footer = document.createElement('div');
                  footer.classList.add("jky-image-preview-footer");
                  footer.innerHTML = `
                    <div class="jky-image-preview-progress">2 / 2</div>
                    <div class="jky-image-preview-operations">
                        <div class="jky-image-preview-operations-operation jky-image-preview-operations-operation-flipY">
                            <span role="img" aria-label="swap" class="anticon anticon-swap">
                                <svg viewBox="64 64 896 896" focusable="false" data-icon="swap" width="1em" height="1em" fill="currentColor" aria-hidden="true" style="transform: rotate(90deg);">
                                    <path d="M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"></path></svg></span></div><div class="jky-image-preview-operations-operation jky-image-preview-operations-operation-flipX"><span role="img" aria-label="swap" class="anticon anticon-swap"><svg viewBox="64 64 896 896" focusable="false" data-icon="swap" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"></path></svg></span></div><div class="jky-image-preview-operations-operation jky-image-preview-operations-operation-zoomOut jky-image-preview-operations-operation-disabled"><span role="img" aria-label="zoom-out" class="anticon anticon-zoom-out"><svg viewBox="64 64 896 896" focusable="false" data-icon="zoom-out" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"></path>
                                </svg>
                            </span>
                        </div>
                        <div class="jky-image-preview-operations-operation jky-image-preview-operations-operation-zoomIn">
                            <span role="img" aria-label="zoom-in" class="anticon anticon-zoom-in">
                                <svg viewBox="64 64 896 896" focusable="false" data-icon="zoom-in" width="1em" height="1em" fill="currentColor" aria-hidden="true">
                                    <path d="M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"></path>
                                </svg>
                            </span>
                        </div>
                    </div>
                  `
                  fragment.appendChild(closeDom);
                  fragment.appendChild(next);
                  fragment.appendChild(prev);
                  fragment.appendChild(footer);
                  this.appendChild(fragment);
    
    
                  this.rendered = true;
    
                  this.initRenderEvent()
                }
            }
        )
    }
}